import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";

const StudentSubmissions = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  const [studentList, setStudentList] = useState([]);

  //  ------For TableViewer ------
  const studentListRef = useRef([]);
  studentListRef.current = studentList;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //----------------------------------------------- select /  Student List table  -------------------------------------------------R
  // Fetch all studentList
  const getStudentList = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}assignments/student-list/${decodeURIComponent(
          atob(id)
        )}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //  ------For TableViewer ------
            // console.log(data.data);
            const studentListData = data.data.map((student) => ({
              student: student.first_name + " " + student.last_name,
              idNumber: student.studentid,
            }));
            setRowData(studentListData);
            //  ------For TableViewer ------
            setStudentList(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching studentList.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getStudentList();
  }, [token]);

  //----------------------------------------------- select / view single student  -------------------------------------------------R
  const btnShowHandle = async (sid, stdname) => {
    const encodedId = window.btoa(encodeURIComponent(sid));
    navigate(
      `/viewstudentassignment/${id}/${encodedId}/${window.btoa(
        encodeURIComponent(stdname)
      )}`
    );
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      field: "student",
      filter: true,
    },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Assignment" subpath={[" Student List"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0"> Student List</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onView={btnShowHandle}
                showWithTwoPara
                // haveImage
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentSubmissions;
